import React from "react";
import ClientLayerBlueprint from "components/blueprints/ClientLayerBlueprint";
import ClientOrdersTableHeader from "./ClientOrdersTableHeader";
import ClientOrdersPageTable from "./ClientOrdersPageTable";

function ClientOrdersPage() {
  return (
    <section className="bg-gray-100" style={{ minHeight: "calc(100vh - 60px)" }}>
      <div className="container mx-auto">
        <div className="bg-white pt-2 pb-6 shadow-md blur-2 text-opacity-15 spread-0 mb-[30px]">
          <ClientOrdersTableHeader />
          <ClientOrdersPageTable />
        </div>
      </div>
    </section>
  );
}

export default ClientLayerBlueprint(ClientOrdersPage);
